import { WORKFLOW_TRIGGERS } from 'modules/workflows/constants';

/**
 * What the levels of the search query correspond to in the Yes/No split node.
 *
 * NOTE: This will not be the same for all places in which `searchQueries` is
 * used -- only for the Yes/No split node.
 */
export enum YesNoSearchQueryLevels {
  /** Level corresponding to the area where you click "Add Group" */
  Group = 1,
  /** Level corresponding to the area where you choose the data type */
  DataType = 2,
  /** Level corresponding to the area where you set the field, comparator and value */
  Field = 3,
}

/** Triggers in which you cannot determine what the originating event was */
export const INDETERMINABLE_ORIGIN_TRIGGERS = [WORKFLOW_TRIGGERS.TRIGGERED_BY_WORKFLOW];
/** Triggers in which the originating event cannot be filtered */
export const UNFILTERABLE_TRIGGERS = [
  // Fields change trigger is not filterable as per the comments in:
  // [WF-1835](https://iterable.atlassian.net/browse/WF-1835)
  WORKFLOW_TRIGGERS.FIELD_CHANGED,
  WORKFLOW_TRIGGERS.SCHEDULED_RECURRING_LIST,
];
export const ADDED_ITEM_TO_CART_EVENT_NAME = 'updateCart';

export const TRIGGERS_WITH_MIXED_TOP_LEVEL = [WORKFLOW_TRIGGERS.RECEIVED_API];
